jQuery(function($) {
	/* eslint-disable */
	$(".sw-loadmore").click(function() {
		var button = $(this),
			data = {
				action: "loadmore",
				query: sw_loadmore_params.posts,
				page: sw_loadmore_params.current_page
			};

		$.ajax({
			url: sw_loadmore_params.ajaxurl,
			data: data,
			type: "POST",
			success: function(data) {
				if (data) {
					$(".articles-section__content").fadeOut(200, function() {
						$(".articles-section__content")
							.find("article:last-of-type")
							.after(data);
						$(".articles-section__content").fadeIn("slow");
					});

					sw_loadmore_params.current_page++;

					if (sw_loadmore_params.current_page == sw_loadmore_params.max_page) {
						button.remove();
					}
				} else {
					button.remove();
				}
			}
		});
	});
	/* eslint-enable */
});
/* eslint-disable */

// jQuery(function($) {
// 	var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
// 		bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

// 	$(window).scroll(function() {
// 		var data = {
// 			action: "loadmore",
// 			query: sw_loadmore_params.posts,
// 			page: sw_loadmore_params.current_page
// 		};
// 		if (
// 			$(document).scrollTop() > $(document).height() - bottomOffset &&
// 			canBeLoaded == true
// 		) {
// 			$.ajax({
// 				url: sw_loadmore_params.ajaxurl,
// 				data: data,
// 				type: "POST",
// 				beforeSend: function(xhr) {
// 					// you can also add your own preloader here
// 					// you see, the AJAX call is in process, we shouldn't run it again until complete
// 					canBeLoaded = false;
// 				},
// 				success: function(data) {
// 					if (data) {
// 						$(".articles-section__content")
// 							.find("article:last-of-type")
// 							.after(data); // where to insert posts
// 						canBeLoaded = true; // the ajax is completed, now we can run it again
// 						sw_loadmore_params.current_page++;
// 					}
// 				}
// 			});
// 		}
// 	});
// });

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/loadmore.js